module.exports = __webpack_public_path__ + "static/sphere-ceab23ad1ff88b986523ffd60fdbe336.gif";